import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enUS from '@/locale/language/en-US'
import enAU from '@/locale/language/en-AU'
import enUK from '@/locale/language/en-UK'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'en-AU',
  fallbackLocale: 'en-US',
  messages: {
    'en-AU': enAU,
    'en-UK': enUK,
    'en-US': enUS
  }
})
